module.exports = new __parcel__URL__("settings.92ba71a7.jpeg").toString();